/**
 * returns true if a tab is targetted in the event object.
 * @param   {Object} e the event object
 * @returns {Boolean}  the boolean that is true if a tab is targetted in the event object.
 */
const checkTabButtonTargetted = (e) => !!e.target.closest('.tab');

export default checkTabButtonTargetted;
